import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';

const Compass = ({ angle }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '34px',
      height: '34px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: grey[800],
      borderRadius: '100px',
      backgroundColor: 'white',
      svg: { width: '22px', height: '22px' },
    }}
  >
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 120"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
    >
      <path
        d="M10.54,0.709l-9.831,55.012l21.718,0l-11.887,-55.012Z"
        style={{
          fill: '#ec2f2f',
          fillRule: 'nonzero',
          stroke: '#000',
          strokeWidth: '1px',
          transform: `rotate(${-1 * (angle + 180)}deg)`,
          transformOrigin: '50%',
        }}
      />
      <path
        d="M10.54,118.34l-9.831,-55.013l21.718,0l-11.887,55.013Z"
        style={{
          fill: '#fff',
          fillRule: 'nonzero',
          stroke: '#000',
          strokeWidth: '1px',
          transform: `rotate(${-1 * (angle + 180)}deg)`,
          transformOrigin: '50%',
        }}
      />
    </svg>
  </Box>
);

export default Compass;
